import React from "react";

export const Footer = () => {
  return (
    <>
      <div className="navbar navbar-expand-lg bg-dark text-light text-center footer-style ">
        <p> Copyright &copy; MyToDosList.com </p>
      </div>
    </>
  );
};
